import React from 'react';
import cn from 'classnames';

import styles from './ButtonSet.module.postcss';

function ButtonSet({ children, className }) {
  return (
    <div className={cn(styles.ButtonSet, className)}>
      {children}
    </div>
  );
}

export default ButtonSet;
